import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {DataService} from '../../../core/services/data.service';

@Component({
  selector: 'app-alert-ekyc',
  templateUrl: './alert-ekyc.component.html',
  styleUrls: ['./alert-ekyc.component.scss']
})
export class AlertEkycComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertEkycComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string,
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  onNoClick() {
    // this.dataService.setCloseDialogOutOfContractQuantity(true);
    this.dialogRef.close();
  }

}
